import React from "react";
import BaseModal from "views/uikit/VLModal/BaseModal";
import VLButton from "views/uikit/Buttons/VLButton";
import styles from "./style.module.scss";

interface DeleteModelConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  title?: string;
  subTitle?: string;
}

const DeleteModelConfirmationModal: React.FC<
  DeleteModelConfirmationModalProps
> = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
  title = "Delete Model",
  subTitle = "Are you sure you want to delete this model?",
}) => {
  const footer = (
    <div className={styles.footer}>
      <VLButton
        type="default"
        text="Cancel"
        onClick={onClose}
        disabled={loading}
        className={styles.cancelButton}
      />
      <VLButton
        type="primary"
        text="Yes, delete"
        onClick={onConfirm}
        loading={loading}
        className={styles.confirmButton}
      />
    </div>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      variant="error"
      headers={{
        title,
        subTitle,
      }}
      footer={footer}
      size="default"
    >
      <div className={styles.description}>
        This will permanently remove it from the VL catalog.
      </div>
    </BaseModal>
  );
};

export default DeleteModelConfirmationModal;
